import Statement from "../components/Statement";
import { PortalMessages } from "../components/Messages";

export default function AgentPortal() {
  return (
    <>
      <PortalMessages />
      <Statement eyebrow="My residuals" />
    </>
  );
}
